import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("path", { d: "M14.31 12.41L13 13.66V8a1 1 0 00-2 0v5.59l-1.29-1.3a1.004 1.004 0 10-1.42 1.42l3 3a1 1 0 00.33.21.94.94 0 00.76 0 .54.54 0 00.16-.1.49.49 0 00.15-.1l3-2.86a1 1 0 00-1.38-1.45z" }), /* @__PURE__ */ _jsx("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16z" })]
		})
	})
});
export { SvgDownload as ReactComponent };
